<template>
  <div style="padding-bottom:44px">
    <van-field label="序列号" v-model="ysy002_Step2.serialNumber">
      <template #right-icon>
        <van-tag type="warning">{{jieMa}}</van-tag>
      </template>
    </van-field>
    <van-cell title="上电检测3V 5V">
      <template #right-icon>
        <van-checkbox v-model="ysy002_Step2.shangDianJianCe35" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="液晶显示测试">
      <template #right-icon>
        <van-checkbox v-model="ysy002_Step2.yeJingXianShiCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="按键测试">
      <template #right-icon>
        <van-checkbox v-model="ysy002_Step2.anJianCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="蜂鸣器测试">
      <template #right-icon>
        <van-checkbox v-model="ysy002_Step2.fengMingQiCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="循环继电器测试">
      <template #right-icon>
        <van-checkbox v-model="ysy002_Step2.xunHuanJiDianQiCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="制冷继电器测试">
      <template #right-icon>
        <van-checkbox v-model="ysy002_Step2.zhiLengJiDianQiCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="加热固态继电器测试">
      <template #right-icon>
        <van-checkbox v-model="ysy002_Step2.jiaReGuJianJiDianQiCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="电机正反转测试">
      <template #right-icon>
        <van-checkbox v-model="ysy002_Step2.dianJiZhengFanZhuanCeShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="温度测试显示">
      <template #right-icon>
        <van-checkbox v-model="ysy002_Step2.wenDuCeShiXianShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-cell title="时间运行测试">
      <template #right-icon>
        <van-checkbox v-model="ysy002_Step2.shiJianYunXingXianShi" shape="square"></van-checkbox>
      </template>
    </van-cell>
    <van-field label="备注" v-model="ysy002_Step2.remark"> </van-field>
    <el-button type="primary" class="footer1" icon="el-icon-view" circle @click="handlePicClick"></el-button>
    <div class="footer">
      <van-button type="info" v-show="$parent.hasPower_Step2" round block :disabled="$parent.ysy002_SignNumber.status!=0" @click="handleSave">保存</van-button>
      <van-button type="danger" v-if="$parent.ysy002_SignNumber.status==2" round block @click="$parent.cancel_void_SignNumber()">取消作废</van-button>
      <van-button type="danger" v-else-if="$parent.ysy002_SignNumber.status!=1" round block @click="$parent.void_SignNumber()">作废</van-button>

    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  props: ["signNumber"],
  data() {
    return {
      ysy002_Step2: {},
      jieMa: "",
    };
  },
  methods: {
    handlePicClick() {
      ImagePreview(["./images/YSY002_Produce1.png"]);
    },
    getYSY002_Step2() {
      let that = this;
      that.axios
        .post("/YSY002/GetYSY002_Step2", { onlyText: that.signNumber })
        .then(function (response) {
          that.ysy002_Step2 = response.data.data;
        });
    },
    handleSave() {
      let that = this;
      that.axios
        .all([that.save_YSY002_Step2(), that.registerSerialNumber()])
        .then(
          that.axios.spread(function (response1, response2) {
            that.ysy002_Step2 = response1.data.data;
            if (response1.data.code == 201) {
              that.$notify({ type: "warning", message: response1.data.msg });
            } else if (response2.data.code == 201) {
              that.$notify({ type: "warning", message: response2.data.msg });
            } else {
              that.$notify({ type: "success", message: response1.data.msg });
            }
            if (response2.data.code == 101) {
              that.jieMa = response2.data.msg;
            }
          })
        );
    },
    save_YSY002_Step2() {
      let that = this;
      return that.axios.post("YSY002/UpdateYSY002_Step2", that.ysy002_Step2);
    },
    registerSerialNumber() {
      let that = this;
      return that.axios.post("Base_Device/Register", {
        productName: "延伸仪",
        productId: 1082,
        serialNumber: that.ysy002_Step2.serialNumber,
        deviceType: "YSY002",
        companyName: "",
        ifPrint: false,
      });
    },
  },
  mounted() {
    let that = this;
    that.getYSY002_Step2();
  },
};
</script>

<style scoped>
.footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
}
.footer1 {
  position: fixed;
  left: 10px;
  bottom: 50px;
}
</style>